module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoUL.fa20f8e.ttf";